import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  id: string;
  data: any; //TODO: fix type;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  id: "",
  data: null,
};

const getEmployeeArriveLateDetailSlice = createSlice({
  name: "getEmployeeArriveLateDetail",
  initialState,
  reducers: {
    setEmployeeArriveLateDetailId: (state, action: PayloadAction<string>) => {
      state.id = action.payload;
    },
    resetEmployeeArriveLateDetailId: (state) => {
      state.id = "";
    },
    getEmployeeArriveLateDetailStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    getEmployeeArriveLateDetailSuccess: (state, action: PayloadAction<any>) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },

    getEmployeeArriveLateDetailFailed: (
      state,
      action: PayloadAction<string>
    ) => {
      state.status = ReduxStateType.ERROR;
      state.data = action.payload;
    },
    resetEmployeeArriveLateDetail: () => {
      return { ...initialState };
    },
  },
});

export const {
  setEmployeeArriveLateDetailId,
  resetEmployeeArriveLateDetailId,
  getEmployeeArriveLateDetailStart,
  getEmployeeArriveLateDetailSuccess,
  getEmployeeArriveLateDetailFailed,
  resetEmployeeArriveLateDetail,
} = getEmployeeArriveLateDetailSlice.actions;

export default getEmployeeArriveLateDetailSlice.reducer;
